import { GOGO_MASTER_DATA_BASE_URL } from "@/config/api";

const FETCH_HEADERS: Record<string, string> = {
  Accept: "application/json",
  "User-Agent": "PetrominWebsite/1.0",
};

async function readJson(
  url: string,
  cache: RequestCache | undefined = "default"
): Promise<unknown> {
  const res = await fetch(url, {
    headers: FETCH_HEADERS,
    cache,
    ...(cache === "default"
      ? { next: { revalidate: 300 } }
      : {}),
  });
  if (!res.ok) {
    throw new Error(`GoGo master-data ${res.status}: ${url}`);
  }
  return res.json();
}

export async function fetchGogoMakes(languageId: number): Promise<unknown> {
  const q = new URLSearchParams({ languageId: String(languageId) });
  return readJson(`${GOGO_MASTER_DATA_BASE_URL}/makes?${q}`);
}

export async function fetchGogoModelYears(): Promise<unknown> {
  return readJson(`${GOGO_MASTER_DATA_BASE_URL}/model-years`);
}

export async function fetchGogoModels(
  makeId: number,
  modelYearId: number,
  languageId: number
): Promise<unknown> {
  const q = new URLSearchParams({
    modelYearId: String(modelYearId),
    languageId: String(languageId),
  });
  return readJson(`${GOGO_MASTER_DATA_BASE_URL}/${makeId}/models?${q}`, "no-store");
}

export async function fetchGogoTrims(
  modelId: number,
  languageId: number
): Promise<unknown> {
  const q = new URLSearchParams({ languageId: String(languageId) });
  return readJson(
    `${GOGO_MASTER_DATA_BASE_URL}/models/${modelId}/trims?${q}`,
    "no-store"
  );
}

/**
 * @deprecated Use `fetchPetrominCities` / `fetchCitiesClient` (Petromin CS `GET /cities`).
 * Paginated cities from GoGo master-data v2 (optional `searchKey`, e.g. `Med`).
 */
export async function fetchGogoCities(params: {
  languageId: number;
  page: number;
  limit: number;
  searchKey?: string;
}): Promise<unknown> {
  const q = new URLSearchParams({
    languageId: String(params.languageId),
    page: String(params.page),
    limit: String(params.limit),
  });
  const sk = params.searchKey?.trim();
  if (sk) q.set("searchKey", sk);
  return readJson(
    `${GOGO_MASTER_DATA_BASE_URL}/v2/cities?${q}`,
    "no-store"
  );
}
